import {UserModel} from '@@/package/mapper/user/model/UserModel';
import type UserResponse from '@@/package/apis/user/response/UserResponse';
import type UserV2Response from "~~/package/apis/user/response/UserV2Response";
import {UserV2Model} from "~~/package/mapper/user/model/UserV2Model";
import {CountryModel} from "~~/package/mapper/user/model/CountryModel";

export class UserHelper {
    public static mappingUser(user: UserResponse): UserModel {
        return UserModel.create(user);
    }

    public static mappingUserV2(user: UserV2Response): UserV2Model {
        return UserV2Model.create({
            ...user,
            locale: user.locale || "en",
        });
    }

    public static mappingCountryData(country: CountryModel): CountryModel {
        return CountryModel.create({
            ...country,
            englishName: country.englishName.slice(0, country.englishName.indexOf('(')).trim(),
            koreanName: country.koreanName.slice(0, country.koreanName.indexOf('(')).trim(),
            japaneseName: country.japaneseName.slice(0, country.japaneseName.indexOf('(')).trim()
        });
    }

    public static mappingCountryDataForContactUs(country: CountryModel): CountryModel {
        const newCountry = new CountryModel();
        newCountry.id = country.id;
        newCountry.nationCode = country.nationCode;

        if (country.englishName) {
            newCountry.name = country.englishName;
        } else {
            for (const key in country) {
                if (key.includes("Name")) {
                    newCountry.name = country[key as keyof typeof country] as string;
                    break;
                }
            }
        }

        return newCountry;
    }
}
